import script from "./device.vue?vue&type=script&setup=true&lang=js"
export * from "./device.vue?vue&type=script&setup=true&lang=js"

import "./device.vue?vue&type=style&index=0&id=22b3f974&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b3f974"]])

export default __exports__